
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M21.29 4.11997L16.7 8.70997L18.29 10.3C18.92 10.93 18.47 12.01 17.58 12.01H13C12.45 12.01 12 11.56 12 11.01V6.40997C12 5.51997 13.08 5.06997 13.71 5.69997L15.3 7.28997L19.89 2.69997C20.28 2.30997 20.91 2.30997 21.3 2.69997C21.68 3.09997 21.68 3.72997 21.29 4.11997ZM4.12 21.29L8.71 16.7L10.3 18.29C10.93 18.92 12.01 18.47 12.01 17.58V13C12.01 12.45 11.56 12 11.01 12H6.41C5.52 12 5.07 13.08 5.7 13.71L7.29 15.3L2.7 19.89C2.31 20.28 2.31 20.91 2.7 21.3C3.1 21.68 3.73 21.68 4.12 21.29Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-close-fullscreen`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconCloseFullscreen

    ```js
    <b-new-b-icon-close-fullscreen />
    ```
</docs>


